interface TableUIProps {
  headers: string[];
  rows: any[];
}

function TableUI({ headers, rows }: TableUIProps) {
  return (
    <div className="w-full h-80 overflow-auto scrollbar-hide">
      <table className="table-auto w-full text-left whitespace-no-wrap">
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th
                key={index}
                className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-100 rounded-tl rounded-bl"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              {headers.map((header, cellIndex) => (
                <td
                  key={cellIndex}
                  className="border-t-2 border-gray-200 px-4 py-2 text-sm"
                >
                  {row[header]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default TableUI;
